const DEFAULT_SUGGESTIONS = ['生活', '阅读', '产品', '技术', '哲学', '管理', '创业', '投资']
const DEFAULT_LIMIT = 12

export function normalizeKeyword(keyword) {
  return (keyword || '').toString().trim()
}

function fallbackSuggestions(limit = DEFAULT_LIMIT) {
  return DEFAULT_SUGGESTIONS.slice(0, limit)
}

export async function fetchSearchSuggestions(http, baseUrl, options = {}) {
  const limit = Math.min(options.limit || DEFAULT_LIMIT, 50)
  const tag = normalizeKeyword(options.tag || '')
  const params = [`limit=${encodeURIComponent(limit)}`]
  if (tag) {
    params.push(`tag=${encodeURIComponent(tag)}`)
  }
  const query = params.length ? `?${params.join('&')}` : ''
  const url = `${baseUrl}/blog/api/search/suggestions${query}`
  try {
    const response = await http.get(url)
    const payload = JSON.parse(response.bodyText)
    const suggestions = (payload && payload.suggestions) || []
    return suggestions.length ? suggestions : fallbackSuggestions(limit)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('fetch suggestions failed', error)
    return fallbackSuggestions(limit)
  }
}

export function getDefaultSuggestions(limit = DEFAULT_LIMIT) {
  return fallbackSuggestions(limit)
}
